import React from 'react'

import { Button } from '@nazka/nazka.mapframe.components'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from '@utils/i18n/i18n.consumers';
import Navbar from '../../components/Navbar/Navbar'
import ScreenNotSupported from '../../components/ScreenNotSupported/ScreenNotSupported'

import './explore-page.styl'

function ExplorePage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <div className="explore-page">
      <ScreenNotSupported />
      <Navbar explore />
      <div className="explore-page__content">
        <h2>{t('Begin your exploration')}</h2>
        <div className="explore-page__category-btn">
          <div className="explore-page__category-btn__item">
            <Button
              themeColor="secondary"
              onClick={() => navigate('/learn')}
              className="explore-page__category-btn__btn"
              icon="/img/icons/learn-summary.svg"
              // iconSize="60px"
            />
            <span className="explore-page__category-btn__btn__text">{t('Learn about climate change')}</span>
          </div>
          <div className="explore-page__category-btn__item">
            <Button
              themeColor="secondary"
              onClick={() => navigate('/risks')}
              className="explore-page__category-btn__btn"
              icon="/img/icons/risk-summary.svg"
              // iconSize="60px"
            />
            <span className="explore-page__category-btn__btn__text">{t('Explore climate risk data')}</span>
          </div>
          <div className="explore-page__category-btn__item">
            <Button
              themeColor="secondary"
              onClick={() => navigate('/adaptation')}
              className="explore-page__category-btn__btn"
              icon="/img/icons/adaptation-summary.svg"
              // iconSize="60px"
            />
            <span className="explore-page__category-btn__btn__text">{t('Explore adaptation plans - stories')}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ExplorePage